export const ACCOUNT_CATEGORIES_RESET_STATE = 'ACCOUNT_CATEGORIES_RESET_STATE';
export const ACCOUNT_CATEGORIES_CURRENT_ITEM = 'ACCOUNT_CATEGORIES_CURRENT_ITEM';

export const ACCOUNT_CATEGORIES_REQUEST_LOADING = 'ACCOUNT_CATEGORIES_REQUEST_LOADING';
export const ACCOUNT_CATEGORIES_REQUEST_SUCCESS = 'ACCOUNT_CATEGORIES_REQUEST_SUCCESS';
export const ACCOUNT_CATEGORIES_REQUEST_FAILED = 'ACCOUNT_CATEGORIES_REQUEST_FAILED';

export const ACCOUNT_CATEGORIES_CURRENT_ACTION = 'ACCOUNT_CATEGORIES_CURRENT_ACTION';
export const ACCOUNT_CATEGORIES_RESET_ACTION = 'ACCOUNT_CATEGORIES_RESET_ACTION';